import { all, takeLatest } from "redux-saga/effects";
import * as SAGA from "./saga-actions";
import * as SAGABROADCAST from "./saga-broadcast";
import * as SagaLoadChat from "./saga-loadChat";
import * as SagaClaimedPatientByUSer from "./saga-claimedUser";
import * as SagaRevoke from "./saga-revoke";
import * as SagaUploadLink from "./saga-uploadLink";
import * as SagaDocSignLink from "./saga-docSignLink";
import * as SagaFileUpload from "./saga-fileUpload";
import * as SagaFileDownload from "./saga-fileDownload";
import * as SagaSignedDocDownload from "./saga-docSignDownload";
import * as SagaCheckPermission from "./saga-checkPermission";
import * as SagaTypes from "./saga-types";
import { setPopupFunc } from "../actions/popupAction";
import { SET_POPUP, NOTIFICATION_ALERT } from "../constants/constants";
import * as SagaRevokeClient from "./saga-revokeClient";
import * as SagaClaimChatByAgent from "./saga-claimChat";
import { setUnreadMsgFunc } from "../actions/unreadAction";
import { UNREAD_MSG } from "../constants/constants";
import { setNotificationAlertMsgFunc } from "../actions/notificationAlertAction";

/************** Bind all saga function here ***********/

export default function* sagaFun() {
  yield all([
    takeLatest(SagaTypes.FETCH_PATIENTS, SAGA.findpatients),

    takeLatest(SagaTypes.FETCH_MORE_PATIENTS, SAGA.findMorepatients),

    takeLatest(SagaTypes.FETCH_CHAT_PATIENT, SAGA.fetchChatPatient),

    takeLatest(SagaTypes.CHECK_USER, SAGA.getUsers),

    takeLatest(SagaTypes.SIGNUP_USER, SAGA.signUpUser),

    takeLatest(SagaTypes.ADD_PATIENT, SAGA.addPatientData),

    takeLatest(SagaTypes.LOGIN_USER, SAGA.loginSagaData),

    takeLatest(SagaTypes.JWT_TOKEN_SAGA, SAGA.jwtTokenSagaData),

    takeLatest(SagaTypes.EMPTY_PATIENT, SAGA.emptyReducer),

    takeLatest(
      SagaTypes.CHECK_USER_PERMISSION,
      SagaCheckPermission.checkPermissionByUser
    ),

    takeLatest(
      SagaTypes.UPLOAD_BROADCAST_FILE_NEW,
      SAGABROADCAST.uploadBroadCastFileNew
    ),

    takeLatest(
      SagaTypes.UPLOAD_BROADCAST_COMMA_SEPARATED_VALUES,
      SAGABROADCAST.uploadBroadCastCommaSeparatedValues
    ),

    takeLatest(SagaTypes.BROADCAST_MESSAGE, SAGABROADCAST.broadCastMessage),

    takeLatest(
      SagaTypes.BROADCAST_MESSAGE_REVIEW,
      SAGABROADCAST.broadCastMessageReview
    ),

    takeLatest(SagaTypes.EMPTY_BROADCAST, SAGABROADCAST.emptyBroadcast),

    takeLatest(SagaTypes.FETCH_ACTIVE_PATIENTS, SAGA.activePatientsSaga),

    takeLatest(SagaTypes.FETCH_UNCLAIMED_PATIENTS, SAGA.unclaimedPatientsSaga),

    takeLatest(SagaTypes.FETCH_OTHER_PATIENTS, SAGA.otherPatientsSaga),

    takeLatest(SagaTypes.FETCH_QUEUED_PATIENTS, SAGA.queuedPatientsSaga),

    takeLatest(
      SagaTypes.EMPTY_MESSAGE_PATIENT,
      SAGABROADCAST.emptyPatientMessage
    ),

    takeLatest(SagaTypes.LOAD_OLD_CHAT, SagaLoadChat.loadUserPatientChatWorker),

    takeLatest(
      SagaTypes.CONVERT_UNCLAIMED_PATIENT_TO_CLAIMED_PATIENT,
      SagaClaimedPatientByUSer.convertUnclaimedToClaimedUser
    ),

    takeLatest(
      SagaTypes.CONVERT_CLAIMED_TO_UNCLAIMED_PATIENT,
      SagaRevoke.convertClaimedToUnclaimed
    ),

    takeLatest(
      SagaTypes.SEND_UPLOAD_LINK_TO_PATIENT,
      SagaUploadLink.sendUploadLinktoPatientByUser
    ),

    takeLatest(
      SagaTypes.SEND_DOC_SIGN_LINK_TO_PATIENT,
      SagaDocSignLink.sendDocumentSignLinkByUser
    ),

    takeLatest(
      SagaTypes.UPLOAD_PATIENT_FILES,
      SagaFileUpload.uploadPatientFilesByPatient
    ),

    takeLatest(
      SagaTypes.DOWNLOAD_PATIENT_FILES,
      SagaFileDownload.downloadPatientFilesByPatient
    ),

    takeLatest(
      SagaTypes.DOWNLOAD_SIGNED_DOC,
      SagaSignedDocDownload.downloadSignedDocByPatient
    ),

    takeLatest(
      SagaTypes.SHIFT_PATIENT_TO_TOP_SAGA_TYPE,
      SAGA.shiftPatientToTopSaga
    ),

    takeLatest(
      SagaTypes.UPDATE_OTHER_PATIENT_LIST_TYPE,
      SAGA.updateOtherListSaga
    ),

    // takeLatest(
    //   SagaTypes.UPDATE_MESSAGE_STATUS_SAGA_TYPE,
    //   SagaLoadChat.updateMessageStatusPatientSaga
    // ),

    takeLatest(SagaTypes.GET_PATIENT_COUNT, SAGA.patientCount),

    takeLatest(
      SagaTypes.BROADCAST_PATIENT_LIST,
      SAGABROADCAST.broadCastPatientList
    ),

    takeLatest(
      SagaTypes.BROADCAST_EMPLOYEE_LIST,
      SAGABROADCAST.broadCastEmployeeList
    ),

    takeLatest(
      SagaTypes.DELETE_BROADCAST_PATIENT_LIST,
      SAGABROADCAST.removeBroadCastPatientList
    ),

    takeLatest(
      SagaTypes.DELETE_BROADCAST_EMPLOYEE_LIST,
      SAGABROADCAST.removeBroadCastEmployeeList
    ),

    takeLatest(
      SagaTypes.DELETE_BROADCAST_APIPATIENT_LIST,
      SAGABROADCAST.removeBroadCastApiPatientList
    ),

    takeLatest(
      SagaTypes.BROADCAST_APIPATIENT_LIST,
      SAGABROADCAST.broadCastApiPatientList
    ),

    takeLatest(
      SagaTypes.BROADCAST_PROVIDERS_LIST,
      SAGABROADCAST.broadCastProvidersList
    ),

    takeLatest(SagaTypes.CANCEL_MESSAGE, SAGABROADCAST.cancelMessage),

    takeLatest(SET_POPUP, setPopupFunc),

    takeLatest(SagaTypes.FETCH_LIVE_AGENT_CHAT, SAGA.liveAgentChatSaga),

    takeLatest(SagaTypes.GET_CHAT_COUNT, SAGA.liveAgentChatCount),

    takeLatest(
      SagaTypes.CONVERT_ACTIVE_TO_CLOSED_CHAT,
      SagaRevokeClient.convertActiveToClosed
    ),

    takeLatest(
      SagaTypes.CONVERT_CLOSED_CHAT_TO_ACTIVE_CHAT,
      SagaClaimChatByAgent.convertClosedToActiveChat
    ),

    takeLatest(SagaTypes.SHIFT_CHAT_TO_TOP_SAGA_TYPE, SAGA.shiftChatToTopSaga),

    takeLatest(UNREAD_MSG, setUnreadMsgFunc),

    takeLatest(
      SagaTypes.BROADCAST_PREVIEW_LIST,
      SAGABROADCAST.broadCastPreviewList
    ),

    takeLatest(NOTIFICATION_ALERT, setNotificationAlertMsgFunc),
    takeLatest(SagaTypes.GET_NOTIFICATION_COUNT, SAGA.notificationCount),
  ]);
}
